// @ts-nocheck
/* eslint-disable */

import { useCallback, useMemo, useState, useEffect } from 'react';
import useScript, { UseScriptOptions } from './hook';
import { useRouter } from 'next/router';
import useUser from '~/lib/user';
import { useCookies } from 'react-cookie';

const HIDE_PRIVY_NOV_2020 = 'hide_privy_nov_2020';

export default function usePrivy() {
  const { isLoading, user } = useUser();
  const router = useRouter();
  const [cookies, setCookie] = useCookies([HIDE_PRIVY_NOV_2020]);
  const [privyShown, setPrivyShown] = useState<boolean>(false);
  const isAnon = !isLoading && !user?.id;
  const utmSource = router?.query?.utm_source;
  const allowByQueryParam = !!utmSource && !cookies[HIDE_PRIVY_NOV_2020];

  useEffect(() => {
    if (privyShown) {
      setCookie(HIDE_PRIVY_NOV_2020, 'true', {
        maxAge: 60 * 60 * 24,
      });
    }
  }, [privyShown]);

  const initPrivy = useCallback(() => {
    if (typeof window === 'undefined') return;
    window._d_site = 'BB924CED6226F3A9A3091210'; // eslint-disable-line no-underscore-dangle
    window['Privy'] =
      window['Privy'] ||
      function () {
        (window['Privy'].q = window['Privy'].q || []).push(arguments); // eslint-disable-line prefer-rest-params
      };

    setPrivyShown(true);
  }, [setPrivyShown]);

  const destroyPrivy = useCallback(() => {
    if (window._d_site) delete window._d_site; // eslint-disable-line no-underscore-dangle
    document.getElementById('privy-container')?.remove();
    delete window['Privy'];
    delete window['PrivyWidget'];
    window['Privy'] =
      window['Privy'] ||
      function () {
        (window['Privy'].q = window['Privy'].q || []).push(arguments); // eslint-disable-line prefer-rest-params
      };
  }, []);

  const options: UseScriptOptions = useMemo(
    () => ({
      onInit: initPrivy,
      onRemove: destroyPrivy,
    }),
    [initPrivy, destroyPrivy],
  );

  // if privy is allowed, load it now
  useScript(
    isAnon && (privyShown || allowByQueryParam)
      ? 'https://widget.privy.com/assets/widget.js'
      : null,
    options,
  );
}
